import React from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { UserCircle2 } from "lucide-react";

interface ClientAvatarProps {
  imageUrl: string | null;
  name: string;
  initials: string;
  avatarColor: string;
}

const ClientAvatar = ({ imageUrl, name, initials, avatarColor }: ClientAvatarProps) => {
  return (
    <Avatar className={`${imageUrl ? '' : avatarColor} h-16 w-16 border-4 border-white shadow-lg text-white text-2xl`}>
      {imageUrl ? (
        <AvatarImage src={imageUrl} alt={name} className="object-cover" />
      ) : (
        <AvatarFallback className="bg-gradient-to-br from-[#E8F0F8] to-[#3BAFDA]/30 flex items-center justify-center w-full h-full rounded-full border-2 border-[#CCCCCC] shadow-md">
          <UserCircle2 className="h-12 w-12 text-[#3BAFDA]/80" />
        </AvatarFallback>
      )}
    </Avatar>
  );
};

export default ClientAvatar;
